import SubmitTestCaseModal from './SubmitTestCaseModal';

export default SubmitTestCaseModal;
